<template>
    <div class="wrappers">
        <div class="flex justify-between items-center">
            <el-tabs v-model="curTab">
                <el-tab-pane v-for="tab in tabs" :label="tab.name" :name="tab.key" :key="tab.key"></el-tab-pane>
            </el-tabs>
            <Search :placeholder="$t('搜索关键词')" @search="search"></Search>

        </div>
        <div class="rules">
            <div v-for="item in pager.items" :key="item.id" class="rule grid ">
                <div class="px-5 truncate w-full text-left self-center">
                    <span>{{ item.name }}</span>
                    <template v-if="item.rules_text">
                        <span class="text-gray-500 pl-10 text-sm">{{ $t('仓储费设置') }}</span>
                        <span class="text-red-600 pl-2 text-sm" v-for="(r, index) in item.rule_list" :key="index">{{
                            `${$p(r.min)}~${$p(r.max)}:${$p(r.exp)}`
                            }}</span>
                    </template>
                </div>
                <div class="place-items-center border-l-2 h-full px-5 py-4 edit cursor-pointer"
                    @click="setEdit(item.id)">
                    <span class="iconfont icon-bianji1"></span>
                    {{ $t('编辑') }}
                </div>
            </div>
            <el-pagination background layout="prev, pager, next" :total="pager.total"
                @current-change="loadMore"></el-pagination>
        </div>
        <el-dialog title="" :visible.sync="isShowEdit" :destroy-on-close="true">
            <div class="form-box px-5">
                <div class="grid name items-center py-4 ">
                    <span class="text-left">{{ $t('名称') }}</span>
                    <el-input v-model="name" :placeholder="$t('请输入规则名称')" class="input"
                        :disabled="isDisable"></el-input>
                </div>
                <div class="rules-box">
                    <div class="grid rule-desc items-center py-4" v-for="(rule, index) in rules" :key="index">
                        <span class="text-left">{{ $t('价格区间') }}</span>
                        <el-input v-model="rule.min"></el-input>
                        <span>~</span>
                        <el-input v-model="rule.max"></el-input>
                        <span>{{ $t('仓储费设置') }}</span>
                        <el-input v-model="rule.exp"></el-input>
                        <span class="iconfont icon-shanchu text-gray-300"></span>
                    </div>

                </div>
                <div class="text-left py-4">
                    <el-button plain class="add-btn">+{{ $t('添加') }}</el-button>
                </div>
                <div class="text-left tips">
                    {{ $t('仓储费:为空时使用商品库设置，10:表示设置为10，10%:表示供货商价格的10%') }}
                </div>

                <div class="btn-box pt-8">
                    <el-button plain class="back-btn" @click="isShowEdit = false">{{ $t('返回') }}</el-button>
                    <el-button type="primary" @click="saveRule">{{ $t('保存') }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Search from "@/components/mine/search.vue";

export default {
    data() {
        return {
            tabs: [{
                key: '',
                name: this.$t('默认规则')
            },
            {
                key: 'diy',
                name: this.$t('自定义规则')
            }
            ],
            curTab: '',
            pager: this.$Pager({
                apiname: 'sup/getProductPriceRules',
                param: () => (this.param)
            }),
            keyword: '',
            isShowEdit: false,
            frame: {
                max: '',
                exp: '',
                min: ''
            },
            rules: [],
            isDisable: false,
            name: '',
            aid: ''
        }
    },
    components:{
        Search
    },
    async mounted() {
        await this.loadData()
    },
    computed: {
        param() {
            let obj = {}
            if (this.curTab) {
                obj.tag = this.curTab
            }
            if (this.keyword) {
                obj.keyword = this.keyword
            }
            return obj
        }
    },
    watch: {
        curTab(v) {
            this.loadData()
        }
    },
    methods: {
        async loadData() {
            await this.pager.first()
        },
        async setEdit(aid) {
            this.aid = aid
            await this.getOriginPriceRule()
            this.isShowEdit = true
        },
        async getOriginPriceRule() {
            this.$doing()
            let res = await this.$callapi('sup/getProductPriceRule', {
                aid: this.aid
            })
            this.$done()
            if (res.code == 0 && res.data) {
                let {
                    name,
                    rules_text,
                    classify_id
                } = res.data
                this.isDisable = classify_id ? true : false
                this.name = name
                let arrs = rules_text.split(',')
                this.rules = arrs.map(arr => {
                    let index1 = arr.indexOf('~')
                    let index2 = arr.indexOf(':')
                    return {
                        max: this.$p(arr.slice(index1 + 1, index2), '', false),
                        exp: this.$p(arr.slice(index2 + 1, arr.length), '', false),
                        min: this.$p(arr.slice(0, index1), '', false)
                    }
                })
            }
        },
        addMore() {
            this.rules.push(this.$deepCopy(this.frame))
        },
        delRule(index) {
            this.rules.splice(index, 1)
        },
        async saveRule() {
            if (!this.name) {
                return this.$toast(this.$t('请输入规则名称'))
            }
            if (!this.rules?.length) {
                return this.$toast(this.$t('请填写价格区间'))
            }
            let arrs = []
            for (let i = 0; i < this.rules.length; i++) {
                let rule = this.rules[i]
                if (rule.exp && (rule.min || rule.min === 0) && (parseFloat(rule.max) > parseFloat(rule.min) || !rule.max)) {
                    arrs.push({
                        exp: this.$transCNY(rule.exp),
                        min: this.$transCNY(rule.min),
                        max: this.$transCNY(rule.max)
                    })
                } else {
                    return this.$toast(this.$t('请检查数据'))
                }
            }
            let r = await this.$query(this.$t('是否保存规则'))
            if (!r) return
            this.$doing()
            let res = await this.$callapi('sup/saveProductPriceRule', {
                rules: arrs,
                name: this.name,
                ruleid: this.aid
            })
            this.$done()
            if (res.code == 0 && res.data) {
                await this.$toast(this.$t('保存成功'))
                this.isShowEdit = false
            }
        },
        async loadMore(e) {
            await this.pager.load(e)

        },
        async search(e){
            this.keyword = e
            await this.loadData()
            
        }
    }
}
</script>
<style lang="scss" scoped>
.el-tabs {
    ::v-deep .el-tabs__nav-wrap::after {
        background-color: transparent;
    }
}

.rules {
    .rule {
        grid-template-columns: 2fr 0.9fr;
        border: 0.1rem solid #d4d4d4;
        margin-bottom: 0.62rem;

        .edit {
            color: #4B81D1;
        }
    }
}

.form-box {



    .name {
        grid-template-columns: 12% 88%;
        border-bottom: 0.063rem solid #e9e9e9;

        .el-input {
            width: 50%;

        }
    }

    .el-input {
        height: 2.75rem;

        ::v-deep.el-input__inner {
            background: #f6f6f6;
            border-radius: 0.25rem;
            border: none;
            text-align: center;

        }
    }

    .rules-box {
        max-height: 40vh;
        overflow-y: scroll;

        .rule-desc {
            grid-template-columns: 12% 19% 4% 19% 13% 19% 14%;
            border-bottom: 0.063rem solid #e9e9e9;
        }
    }

    .add-btn {
        width: 11.625rem;
        border-radius: 0.25rem;
        background: #f6f6f6;
        border: none;
    }

    .tips {
        color: #909090;

        &::before {
            content: '*';
            color: #FF4747;
        }
    }

    .btn-box {

        .el-button {
            width: 7.5rem;
        }
    }
}
</style>